var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg306",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 682.7 682.7",
    style: {
      enableBackground: "new 0 0 682.7 682.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "625.3,400 572,320 562.7,320 562.7,400  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.3,
    y: 40,
    className: "st0",
    width: 281.3,
    height: 40
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "121.3,400 121.3,320 110.7,320 57.4,400  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M442.7,440v60c0,11-9,20-20,20H261.3c-11,0-20-9-20-20v-60H40v202.7h602.7V440H442.7z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.3,400c11,0,20,9,20,20v60h121.3v-60c0-11,9-20,20-20h100V120H161.3v280H261.3z M221.3,160h241.3 c11,0,20,9,20,20s-9,20-20,20H221.3c-11,0-20-9-20-20S210.3,160,221.3,160z M221.3,240h241.3c11,0,20,9,20,20s-9,20-20,20H221.3 c-11,0-20-9-20-20S210.3,240,221.3,240z M221.3,320h161.3c11,0,20,9,20,20s-9,20-20,20H221.3c-11,0-20-9-20-20S210.3,320,221.3,320 z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,662.7c0,11,9,20,20,20h642.7c11,0,20-9,20-20V420c0-0.1,0-0.2,0-0.3c0-0.5,0-1.1-0.1-1.6c0-0.2-0.1-0.4-0.1-0.7 c-0.1-0.4-0.1-0.9-0.2-1.3c-0.1-0.3-0.1-0.6-0.2-0.9c-0.1-0.3-0.2-0.7-0.3-1c-0.1-0.3-0.2-0.7-0.4-1c-0.1-0.3-0.2-0.5-0.3-0.8 c-0.2-0.4-0.4-0.8-0.6-1.2c-0.1-0.2-0.2-0.4-0.3-0.6c-0.3-0.5-0.6-1-0.9-1.5c0-0.1-0.1-0.1-0.1-0.2l0,0c0,0,0-0.1-0.1-0.1 l-79.9-119.9c-3.7-5.6-10-8.9-16.6-8.9h-20V100c0-11-9-20-20-20h-20V20c0-11-9-20-20-20H181.3c-11,0-20,9-20,20v60h-20 c-11,0-20,9-20,20v180H100c-6.7,0-12.9,3.3-16.6,8.9L3.4,408.8c0,0,0,0,0,0.1l0,0.1c-0.1,0.1-0.1,0.2-0.2,0.3 c-0.3,0.5-0.6,0.9-0.8,1.4c-0.1,0.2-0.2,0.4-0.3,0.6c-0.2,0.4-0.4,0.8-0.6,1.2c-0.1,0.3-0.2,0.5-0.3,0.8c-0.1,0.3-0.2,0.7-0.4,1 c-0.1,0.3-0.2,0.7-0.3,1c-0.1,0.3-0.1,0.6-0.2,0.9c-0.1,0.4-0.1,0.9-0.2,1.3c0,0.2-0.1,0.4-0.1,0.6C0,418.6,0,419.1,0,419.7 c0,0.1,0,0.2,0,0.3V662.7z M642.7,642.7H40V440h201.3v60c0,11,9,20,20,20h161.3c11,0,20-9,20-20v-60h200V642.7z M572,320l53.3,80 h-62.6v-80H572z M201.3,40h281.3v40H201.3V40z M161.3,120h361.3v280h-100c-11,0-20,9-20,20v60H281.3v-60c0-11-9-20-20-20h-100V120z  M110.7,320h10.6v80h-64L110.7,320z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.3,200h241.3c11,0,20-9,20-20s-9-20-20-20H221.3c-11,0-20,9-20,20S210.3,200,221.3,200z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.3,280h241.3c11,0,20-9,20-20s-9-20-20-20H221.3c-11,0-20,9-20,20S210.3,280,221.3,280z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.3,360h161.3c11,0,20-9,20-20s-9-20-20-20H221.3c-11,0-20,9-20,20S210.3,360,221.3,360z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchived);
export default __webpack_public_path__ + "static/media/archived.96deb40e.svg";
export { ForwardRef as ReactComponent };